<template>
  <div class="SummaryStrengths">
    <div class="SummaryStrengths__header">Fortalezas</div>
    <div class="SummaryStrengths__containerdata">
      <div class="SummaryStrengths__containerdata__img">
        <template v-if="type == 1">
          <img
            v-if="imgPlayerNew != ''"
            :src="
              simageExists(imgPlayerNew)
                ? imgPlayerNew
                : 'https://golstatsimages.blob.core.windows.net/players-profile/' + this.$route.params.playerId + '.png'
            "
          />
        </template>
        <template v-else>
          <img
            class="logo-img-team"
            v-if="imgPlayerNew != ''"
            :src="
              simageExists(imgPlayerNew)
                ? imgPlayerNew
                : 'https://golstatsimages.blob.core.windows.net/teams-80/' + this.$route.params.teamId + '.png'
            "
          />
        </template>
      </div>
      <div class="SummaryStrengths__containerdata__strengscont">
        <div
          class="strengscont-overlaybackground"
          v-if="type == 1"
          :class="[dataConfigTooltip.visible ? 'visible-overlay' : '']"
        ></div>
        <div class="SummaryStrengths__containerdata__strengscont__references">
          <div class="SummaryStrengths__containerdata__strengscont__references__item auxFont">Tipos:</div>
          <div class="SummaryStrengths__containerdata__strengscont__references__item">
            <div class="circle-item green"></div>
            Ofensiva
          </div>
          <div class="SummaryStrengths__containerdata__strengscont__references__item">
            <div class="circle-item blue"></div>
            Defensiva
          </div>
          <div class="SummaryStrengths__containerdata__strengscont__references__item">
            <div class="circle-item aqua"></div>
            Posesión
          </div>
        </div>
        <div class="container-summarystrengths">
          <template v-for="(strength, index) in strengthsPlayer">
            <div
              :key="index"
              class="SummaryStrengths__containerdata__strengscont__strengsitem"
              :class="strength.category_type == 1 ? '' : strength.category_type == 2 ? 'aqua' : 'blue '"
              @click="clickOpenTooltip(strength.tooltip)"
            >
              <div class="SummaryStrengths__containerdata__strengscont__strengsitem__img">
                <img
                  v-if="strength.logo"
                  :src="
                    simageExists(strength.logo)
                      ? strength.logo
                      : 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/icn_internacionales.png'
                  "
                />
              </div>
              <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont">
                <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row1">
                  <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row1__category">
                    <span
                      class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row1__category__bold"
                    >
                      {{ strength.name }}
                    </span>
                  </div>
                  <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row1__total">
                    {{ strength.total }}
                  </div>
                </div>
                <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__sep"></div>
                <div
                  class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2"
                  v-if="strength.ranking_type != 0"
                >
                  <template v-if="strength.ranking < 4">
                    <template v-if="strength.ranking == 1">
                      <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2__medal">
                        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/medalls@2x.png" />
                      </div>
                    </template>
                    <template v-if="strength.ranking == 2">
                      <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2__medal">
                        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/medalls@2x2.png" />
                      </div>
                    </template>
                    <template v-if="strength.ranking == 3">
                      <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2__medal">
                        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/medalls@2x3.png" />
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="medals-item">{{ strength.ranking }}</div>
                  </template>
                  <div class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2__textposition">
                    <span
                      class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2__textposition__bold"
                      >#{{ strength.ranking }}</span
                    >
                    <template v-if="strength.ranking_type == 1">lugar en la liga</template>
                    <template v-else>lugar en su equipo</template>
                  </div>
                  <div
                    class="SummaryStrengths__containerdata__strengscont__strengsitem__datacont__row2__icon"
                    v-if="strength.team_contribution >= 25 && type == 1"
                  >
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_puzzle@2x.png" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <Tooltip :data="dataConfigTooltip" placement="bottom" v-if="type == 1">
          <div class="tooltip-strengths" ref="collabsibles" :class="[dataConfigTooltip.visible ? 'visible' : '']">
            <div class="tooltip-strengths__category">{{ tooltipData.category }}</div>
            <div class="tooltip-strengths__league">
              <div class="tooltip-strengths__league__img">
                <img
                  v-if="tooltipData.logo__league"
                  :src="
                    simageExists(tooltipData.logo__league)
                      ? tooltipData.logo__league
                      : 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/icn_internacionales.png'
                  "
                />
              </div>
              <div class="tooltip-strengths__league__top">#{{ tooltipData.league_ranking }}</div>
              <div class="tooltip-strengths__league__text">en la liga</div>
            </div>
            <div class="tooltip-strengths__team">
              <div class="tooltip-strengths__team__img">
                <img :src="tooltipData.logo__team" />
              </div>
              <div class="tooltip-strengths__team__top">#{{ tooltipData.team_ranking }}</div>
              <div class="tooltip-strengths__team__text">lugar en su equipo</div>
            </div>
            <div class="tooltip-strengths__teamcont">
              <div class="tooltip-strengths__teamcont__img">
                <img :src="tooltipData.logo__team" />
              </div>
              <div class="tooltip-strengths__teamcont__text">
                Aporta el {{ tooltipData.team_contribution }}% de los {{ tooltipData.category }} de su equipo
              </div>
            </div>

            <div class="tooltip-strengths__contributionmax" v-if="tooltipData.team_contribution >= 25">
              <div class="tooltip-strengths__contributionmax__img">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_puzzle_outline@2x.png" />
              </div>
              <div class="tooltip-strengths__contributionmax__text">
                Este icono aparece cuando el jugador es un actor principal en esta categoría, al aportar más del 25% de
                las acciones de su equipo.
              </div>
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/Elements/Tooltip';
import axios from 'axios';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'SummaryStrengths',
  components: {
    Tooltip,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tooltipData: {},
      clickaux: false,
      strengthsPlayer: [],
      strengthsPlayerAux: [],
      imgPlayerNew: '',
      photo: '',
      dataConfigTooltip: {
        x: 0,
        y: 0,
        visible: false,
      },
    };
  },
  watch: {
    seasonId: {
      immediate: true,
      handler: function(newValue) {
        if (newValue) {
          this.fillData();
        }
      },
    },
  },
  computed: {
    ...mapState('filterGeneral', ['isPlayerNationalTeam']),
    ...mapState(['windowWidth']),
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
    }),
    ...mapGetters('loginGeneral', ['getTournamentSelected']),
    ...mapGetters('playersGeneral', ['player']),
    ...mapGetters('teamsGeneral', { teamId: 'teamId' }),
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },
  methods: {
    simageExists(image_url) {
      var http = new XMLHttpRequest();

      http.open('HEAD', image_url, false);
      http.send();

      return http.status != 404;
    },
    hideAll() {
      this.dataConfigTooltip.visible = false;
      this.clickaux = false;
    },
    onClickOutside(event) {
      const { collabsibles } = this.$refs;
      if (!collabsibles || collabsibles.contains(event.target)) return;
      if (this.clickaux) {
        this.hideAll();
      } else {
        this.clickaux = true;
      }
    },
    clickOpenTooltip(data) {
      this.tooltipData = data;
      this.dataConfigTooltip.x = 56;
      this.dataConfigTooltip.y = 300;
      if (this.windowWidth <= 1700) {
        this.dataConfigTooltip.x = 50;
        this.dataConfigTooltip.y = 280;
      }
      if (this.windowWidth <= 1600) {
        this.dataConfigTooltip.x = 45;
        this.dataConfigTooltip.y = 260;
      }
      if (this.windowWidth <= 1500) {
        this.dataConfigTooltip.x = 43;
        this.dataConfigTooltip.y = 250;
      }
      if (this.windowWidth <= 1400) {
        this.dataConfigTooltip.x = 39;
        this.dataConfigTooltip.y = 235;
      }
      if (this.windowWidth <= 1300) {
        this.dataConfigTooltip.x = 34;
        this.dataConfigTooltip.y = 220;
      }
      if (this.windowWidth <= 1200) {
        this.dataConfigTooltip.x = 30;
        this.dataConfigTooltip.y = 200;
      }
      if (this.windowWidth <= 1120) {
        this.dataConfigTooltip.x = 65;
        this.dataConfigTooltip.y = 350;
      }
      if (this.windowWidth <= 1080) {
        this.dataConfigTooltip.x = 60;
        this.dataConfigTooltip.y = 350;
      }
      if (this.windowWidth <= 1020) {
        this.dataConfigTooltip.x = 78;
        this.dataConfigTooltip.y = 340;
      }
      if (this.windowWidth <= 950) {
        this.dataConfigTooltip.x = 73;
        this.dataConfigTooltip.y = 300;
      }
      if (this.windowWidth <= 850) {
        this.dataConfigTooltip.x = 69;
        this.dataConfigTooltip.y = 290;
      }
      if (this.windowWidth <= 768) {
        this.dataConfigTooltip.x = 60;
        this.dataConfigTooltip.y = 240;
      }
      if (this.windowWidth <= 700) {
        this.dataConfigTooltip.x = 53;
        this.dataConfigTooltip.y = 240;
      }
      if (this.windowWidth <= 640) {
        this.dataConfigTooltip.x = 47;
        this.dataConfigTooltip.y = 230;
      }
      if (this.windowWidth <= 600) {
        this.dataConfigTooltip.x = 43;
        this.dataConfigTooltip.y = 205;
      }
      if (this.windowWidth <= 580) {
        this.dataConfigTooltip.x = 65;
        this.dataConfigTooltip.y = 370;
      }
      if (this.windowWidth <= 550) {
        this.dataConfigTooltip.x = 58;
        this.dataConfigTooltip.y = 370;
      }
      if (this.windowWidth <= 500) {
        this.dataConfigTooltip.x = 50;
        this.dataConfigTooltip.y = 320;
      }
      if (this.windowWidth <= 460) {
        this.dataConfigTooltip.x = 44;
        this.dataConfigTooltip.y = 320;
      }
      if (this.windowWidth <= 440) {
        this.dataConfigTooltip.x = 40;
        this.dataConfigTooltip.y = 290;
      }
      if (this.windowWidth <= 380) {
        this.dataConfigTooltip.x = 33;
        this.dataConfigTooltip.y = 300;
      }
      if (this.windowWidth <= 350) {
        this.dataConfigTooltip.x = 28;
        this.dataConfigTooltip.y = 275;
      }
      if (this.windowWidth <= 320) {
        this.dataConfigTooltip.x = 26;
        this.dataConfigTooltip.y = 260;
      }
      this.dataConfigTooltip.visible = true;
      // }
    },
    async fillData() {
      try {
        let urlSendAxios = '';
        if (this.type == 1) {
          urlSendAxios =
            'https://5c9xc3gwh2.execute-api.us-east-2.amazonaws.com/prod/strengths/seasons/' +
            this.seasonId +
            '/players/' +
            this.$route.params.playerId;
        } else {
          urlSendAxios =
            'https://5c9xc3gwh2.execute-api.us-east-2.amazonaws.com/prod/strengths/seasons/' +
            this.seasonId +
            '/teams/' +
            this.$route.params.teamId;
        }
        const data = await axios.get(urlSendAxios);
        if (data.data && data.data.season_id === this.seasonId) {
          this.strengthsPlayer = [];
          this.strengthsPlayerAux = [];
          this.photo = '';
          for (let index = 0; index < data.data.strengths.length; index++) {
            if (data.data.strengths[index].ranking_type > 0) {
              const element = {
                name: data.data.strengths[index].name,
                total: data.data.strengths[index].total,
                ranking_type: data.data.strengths[index].ranking_type,
                category_type: data.data.strengths[index].category_type,
                logo:
                  data.data.strengths[index].ranking_type == 1
                    ? data.data.tournament_id == 33
                      ? 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + this.seasonId + '.png'
                      : 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + data.data.tournament_id + '.png'
                    : 'https://golstatsimages.blob.core.windows.net/teams-80/' + data.data.strengths[index].team_id + '.png',
                photo:
                  'https://golstatsimages.blob.core.windows.net/players-profile/' + data.data.strengths[index].player_id + '.png',
                ranking:
                  data.data.strengths[index].ranking_type == 1
                    ? data.data.strengths[index].league_ranking
                    : data.data.strengths[index].team_ranking,
                is_relevant: data.data.strengths[index].is_relevant,
                team_contribution: data.data.strengths[index].team_contribution,
                tooltip: {
                  category: data.data.strengths[index].name,
                  team_contribution: data.data.strengths[index].team_contribution,
                  league_ranking: data.data.strengths[index].league_ranking,
                  team_ranking: data.data.strengths[index].team_ranking,
                  logo__league:
                    data.data.tournament_id == 33
                      ? 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + this.seasonId + '.png'
                      : 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + data.data.tournament_id + '.png',
                  logo__team: 'https://golstatsimages.blob.core.windows.net/teams-80/' + data.data.strengths[index].team_id + '.png',
                },
              };
              this.strengthsPlayer.push(element);
            } else {
              const element = {
                name: data.data.strengths[index].name,
                total: data.data.strengths[index].total,
                ranking_type: data.data.strengths[index].ranking_type,
                category_type: data.data.strengths[index].category_type,
                logo:
                  data.data.strengths[index].ranking_type == 1
                    ? data.data.tournament_id == 33
                      ? 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + this.seasonId + '.png'
                      : 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + data.data.tournament_id + '.png'
                    : 'https://golstatsimages.blob.core.windows.net/teams-80/' + data.data.strengths[index].team_id + '.png',
                photo:
                  'https://golstatsimages.blob.core.windows.net/players-profile/' + data.data.strengths[index].player_id + '.png',
                ranking:
                  data.data.strengths[index].ranking_type == 1
                    ? data.data.strengths[index].league_ranking
                    : data.data.strengths[index].team_ranking,
                is_relevant: data.data.strengths[index].is_relevant,
                team_contribution: data.data.strengths[index].team_contribution,
                tooltip: {
                  category: data.data.strengths[index].name,
                  team_contribution: data.data.strengths[index].team_contribution,
                  league_ranking: data.data.strengths[index].league_ranking,
                  team_ranking: data.data.strengths[index].team_ranking,
                  logo__league:
                    data.data.tournament_id == 33
                      ? 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + this.seasonId + '.png'
                      : 'https://golstatsimages.blob.core.windows.net/golstats2-tournaments/' + data.data.tournament_id + '.png',
                  logo__team: 'https://golstatsimages.blob.core.windows.net/teams-80/' + data.data.strengths[index].team_id + '.png',
                },
              };
              this.strengthsPlayerAux.push(element);
            }
          }

          var restValue = 5 - this.strengthsPlayer.length;
          if (restValue > 0) {
            for (let index = 0; index < restValue; index++) {
              if (this.strengthsPlayerAux[index]) {
                this.strengthsPlayer.push(this.strengthsPlayerAux[index]);
              }
            }
          }
          if (this.type == 1) {
            this.imgPlayerNew =
              'https://golstatsimages.blob.core.windows.net/golstats2-players/' +
              this.$route.params.playerId +
              '_' +
              data.data.team_id +
              '_' +
              this.seasonId +
              '_r1.jpg';
          } else {
            this.imgPlayerNew =
              'https://golstatsimages.blob.core.windows.net/golstats2-teams/' + data.data.team_id + '_' + this.seasonId + '_r1.jpg';
          }
          if (this.type == 1) {
            this.photo = this.strengthsPlayer[0].photo;
          } else {
            this.photo = 'https://golstatsimages.blob.core.windows.net/teams-80/' + this.teamId + '.png';
          }
        }
      } catch (e) {
        throw new Error(e);
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
};
</script>
<style lang="css">
.SummaryStrengths .box-tooltip {
  background-color: transparent !important;
}
</style>
<style scoped lang="scss">
.logo-img-team {
  @media screen and (max-width: 580px) {
    margin-top: -190px;
  }
  @media screen and (max-width: 540px) {
    margin-top: -170px;
  }
  @media screen and (max-width: 500px) {
    margin-top: -160px;
  }
  @media screen and (max-width: 460px) {
    margin-top: -145px;
  }
  @media screen and (max-width: 420px) {
    margin-top: -130px;
  }
  @media screen and (max-width: 380px) {
    margin-top: -120px;
  }
  @media screen and (max-width: 360px) {
    margin-top: -110px;
  }
  @media screen and (max-width: 340px) {
    margin-top: -100px;
  }
}
.visible-overlay {
  display: inline-block !important;
}
.strengscont-overlaybackground {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 2;
}
.container-summarystrengths {
  width: auto;
  height: auto;
  position: relative;
  overflow: auto;
  height: 27.87vw;
  @media screen and (max-width: 1350px) {
    height: 27.57vw;
  }
  @media screen and (max-width: 1220px) {
    height: 26.91vw;
  }
  @media screen and (max-width: 1120px) {
    height: 58.31vw;
  }
  @media screen and (max-width: 580px) {
    height: 106.31vw;
  }
  @media screen and (max-width: 380px) {
    height: 156.31vw;
  }
}
.tooltip-strengths {
  width: 23vw;
  height: auto;
  font-size: 0.8rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 1.784vw;
  line-height: 2;
  letter-spacing: normal;
  color: #ffffff;
  display: inline-block;
  border-radius: 12px;
  box-shadow: 0 16px 36px 0 rgba(18, 35, 49, 0.81);
  background-color: #132839;
  padding-left: 0.784vw;
  padding-right: 0.784vw;
  @media screen and (max-width: 1120px) {
    width: 46vw;
    // height: 28vw;
    padding-left: 1.784vw;
    padding-right: 1.784vw;
  }
  @media screen and (max-width: 580px) {
    width: 88vw;
    // height: 59vw;
    padding-left: 4.2vw;
    padding-right: 4.2vw;
    padding-bottom: 4.784vw;
  }
  @media screen and (max-width: 380px) {
    // height: 64vw;
  }
  &__category {
    height: 1.9vw;
    width: 100%;
    margin-top: 0.647vw;
    line-height: 1.7vw;
    font-family: 'Roboto-Medium';
    font-size: 0.974vw;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: -0.21px;
    text-align: left;
    color: #fff;
    border-bottom: 1px dotted rgba(197, 197, 197, 0.3);
    @media screen and (max-width: 1120px) {
      margin-top: 1.647vw;
      height: 3.9vw;
      font-size: 2.124vw;
      line-height: 4vw;
    }
    @media screen and (max-width: 768px) {
      margin-top: 0.847vw;
      height: 3.9vw;
      font-size: 2.324vw;
      line-height: 3.2vw;
    }
    @media screen and (max-width: 580px) {
      margin-top: 1.427vw;
      height: 8.9vw;
      font-size: 4.1vw;
      line-height: 9.8vw;
    }
  }
  &__league {
    height: 1.9vw;
    width: 100%;
    margin-top: 0.147vw;
    padding-top: 0.357vw;
    padding-bottom: 0.357vw;
    line-height: 1.7vw;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    border-bottom: 1px dotted rgba(197, 197, 197, 0.3);
    @media screen and (max-width: 1120px) {
      margin-top: 0.347vw;
      height: 3.7vw;
      font-size: 2.124vw;
    }
    @media screen and (max-width: 580px) {
      margin-top: 0.447vw;
      height: 9vw;
      font-size: 5.124vw;
    }
    &__img {
      width: 2.4vw;
      height: auto;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 1120px) {
        width: 6.4vw;
      }
      @media screen and (max-width: 580px) {
        width: 10.4vw;
      }
      img {
        width: 2.1vw;
        @media screen and (max-width: 1120px) {
          width: 4.4vw;
        }
        @media screen and (max-width: 580px) {
          width: 9.4vw;
        }
      }
    }
    &__top {
      width: auto;
      height: auto;
      font-family: 'Roboto-Regular';
      font-size: 0.815vw;
      letter-spacing: -0.17px;
      text-align: left;
      color: #cad4dc;
      padding-left: 0.714vw;
      @media screen and (max-width: 1120px) {
        font-size: 1.521vw;
        padding-left: 0.858vw;
      }
      @media screen and (max-width: 580px) {
        font-size: 2.921vw;
        padding-left: 1.358vw;
      }
    }
    &__text {
      width: auto;
      height: auto;
      font-family: 'Roboto-Regular';
      font-size: 0.815vw;
      letter-spacing: -0.17px;
      text-align: left;
      color: #cad4dc;
      padding-left: 0.414vw;
      @media screen and (max-width: 1120px) {
        font-size: 1.521vw;
        padding-left: 0.658vw;
      }
      @media screen and (max-width: 580px) {
        font-size: 2.921vw;
        padding-left: 1.358vw;
      }
    }
  }
  &__team {
    height: 1.9vw;
    width: 100%;
    margin-top: 0.147vw;
    padding-top: 0.357vw;
    padding-bottom: 0.357vw;
    line-height: 1.7vw;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    border-bottom: 1px dotted rgba(197, 197, 197, 0.3);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    @media screen and (max-width: 1120px) {
      margin-top: 0.047vw;
      padding-top: 0.157vw;
      height: 3.7vw;
      font-size: 2.124vw;
    }
    @media screen and (max-width: 580px) {
      margin-top: 0.447vw;
      height: 9vw;
    }
    &__img {
      width: 2.4vw;
      height: 1.8vw;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 1120px) {
        width: 6.4vw;
        height: 2.8vw;
      }
      @media screen and (max-width: 580px) {
        width: 10.4vw;
        height: 7vw;
      }
      img {
        width: 1.5vw;
        @media screen and (max-width: 1120px) {
          width: 2.5vw;
        }
        @media screen and (max-width: 580px) {
          width: 6.9vw;
        }
      }
    }
    &__top {
      width: auto;
      height: auto;
      font-family: 'Roboto-Regular';
      font-size: 0.815vw;
      letter-spacing: -0.17px;
      text-align: left;
      color: #cad4dc;
      padding-left: 0.714vw;
      @media screen and (max-width: 1120px) {
        font-size: 1.521vw;
        padding-left: 0.858vw;
      }
      @media screen and (max-width: 580px) {
        font-size: 2.921vw;
        padding-left: 1.358vw;
      }
    }
    &__text {
      width: auto;
      height: auto;
      font-family: 'Roboto-Regular';
      font-size: 0.815vw;
      letter-spacing: -0.17px;
      text-align: left;
      color: #cad4dc;
      padding-left: 0.414vw;
      @media screen and (max-width: 1120px) {
        font-size: 1.521vw;
        padding-left: 0.658vw;
      }
      @media screen and (max-width: 580px) {
        font-size: 2.921vw;
        padding-left: 1.358vw;
      }
    }
  }
  &__teamcont {
    height: 1.9vw;
    width: 100%;
    margin-top: 0.147vw;
    padding-top: 0.557vw;
    padding-bottom: 0.557vw;
    // line-height: 1.7vw;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    border-bottom: 1px dotted rgba(197, 197, 197, 0.3);
    // text-overflow: ellipsis;
    // overflow: hidden;
    // white-space: nowrap;
    @media screen and (max-width: 1120px) {
      margin-top: 0.647vw;
      height: 3.7vw;
      font-size: 2.124vw;
    }
    @media screen and (max-width: 580px) {
      margin-top: 0.447vw;
      padding-top: 0.257vw;
      height: 9vw;
    }
    &__img {
      width: 2.4vw;
      height: 1.8vw;
      display: inline-block;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 1120px) {
        width: 6.4vw;
        height: 2.8vw;
      }
      @media screen and (max-width: 580px) {
        width: 10.4vw;
        height: 7vw;
      }
      img {
        width: 1.5vw;
        @media screen and (max-width: 1120px) {
          width: 2.5vw;
        }
        @media screen and (max-width: 580px) {
          width: 6.9vw;
        }
      }
    }
    &__top {
      width: auto;
      height: auto;
      font-family: 'Roboto-Regular';
      font-size: 0.815vw;
      letter-spacing: -0.17px;
      text-align: left;
      color: #cad4dc;
      padding-left: 0.714vw;
      visibility: hidden;
      @media screen and (max-width: 1120px) {
        font-size: 1.521vw;
        padding-left: 0.858vw;
      }
      @media screen and (max-width: 580px) {
        font-size: 2.921vw;
        padding-left: 1.358vw;
      }
    }
    &__text {
      width: 90%;
      height: auto;
      font-family: 'Roboto-Regular';
      font-size: 0.815vw;
      letter-spacing: -0.17px;
      text-align: left;
      line-height: 0.9;
      color: #cad4dc;
      padding-left: 0.714vw;
      @media screen and (max-width: 1120px) {
        font-size: 1.521vw;
        padding-left: 0.858vw;
      }
      @media screen and (max-width: 580px) {
        font-size: 2.921vw;
        padding-left: 1.358vw;
      }
    }
  }
  &__contributionmax {
    height: 2.6vw;
    width: 100%;
    margin-top: 0.547vw;
    padding-top: 0.357vw;
    padding-bottom: 0.357vw;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 1120px) {
      height: 6.6vw;
    }
    @media screen and (max-width: 580px) {
      height: 10vw;
    }
    &__img {
      width: 3.8vw;
      height: 2.9vw;
      @media screen and (max-width: 1120px) {
        width: 7.2vw;
        height: 5.9vw;
      }
      @media screen and (max-width: 580px) {
        width: 15.2vw;
        height: 8.9vw;
      }
    }
    &__text {
      width: 18vw;
      padding-left: 0.714vw;
      height: 2.9vw;
      font-family: 'Roboto-regular';
      font-size: 0.747vw;
      font-weight: normal;
      font-stretch: normal;

      font-style: italic;
      line-height: 1.4;
      letter-spacing: -0.15px;
      text-align: left;
      color: #819eb6;
      @media screen and (max-width: 1120px) {
        width: 35.2vw;
        height: 5.9vw;
        font-size: 1.537vw;
      }
      @media screen and (max-width: 580px) {
        width: 64.2vw;
        height: 11.9vw;
        font-size: 2.837vw;
        margin-top: 5.21vw;
        padding-left: 1.714vw;
      }
    }
  }
}
.medals-item {
  width: 1.754vw;
  height: 1.754vw;
  color: white;
  font-family: 'Avenir-Bold';
  font-size: 0.84vw;
  line-height: 1.754vw;
  text-align: center;
  background-color: #aeaeae;
  border-radius: 1.754vw;
  margin-top: 0.198vw;
  @media screen and (max-width: 1120px) {
    width: 3.4vw;
    height: 3.4vw;
    line-height: 3.4vw;
    border-radius: 3.4vw;
    font-size: 1.74vw;
    margin-top: 0.545vw;
  }
  @media screen and (max-width: 580px) {
    width: 5.7vw;
    height: 5.7vw;
    margin-top: 0.945vw;
    border-radius: 5.7vw;
    line-height: 5.7vw;
    margin-left: 1.4vw;
    font-size: 2.4vw;
  }
  @media screen and (max-width: 380px) {
    height: 9.147vw;
    width: 9.147vw;
    border-radius: 9.147vw;
    line-height: 9.147vw;
    margin-top: 1.545vw;
    margin-left: 1.6vw;
    font-size: 3.7vw;
  }
}
.auxFont {
  font-family: 'Roboto-Black' !important;
}
.circle-item {
  width: 0.642vw;
  height: 0.642vw;
  border-radius: 14px;
  margin-top: 0.3vw;
  margin-right: 0.22vw;
  @media screen and (max-width: 1120px) {
    width: 1.224vw;
    height: 1.224vw;
    margin-top: 0.6vw;
    margin-right: 0.42vw;
  }
  @media screen and (max-width: 580px) {
    width: 1.924vw;
    height: 1.924vw;
    margin-top: 0.2vw;
  }
  @media screen and (max-width: 380px) {
    width: 2.924vw;
    height: 2.924vw;
    margin-top: 0vw;
  }
}
.green {
  background-color: #83bf42 !important;
}
.blue {
  background-color: #035eb2 !important;
}
.aqua {
  background-color: #089e9e !important;
}
.SummaryStrengths {
  &__header {
    width: 100%;
    height: 3.558vw;
    border-radius: 1.053vw;
    background-color: #132839;
    font-family: 'Roboto-Regular';
    font-size: 1.368vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 3.558vw;
    letter-spacing: -0.26px;
    text-align: center;
    color: #cbee6b;
    display: inline-block;
    @media screen and (max-width: 1120px) {
      height: 4.518vw;
      line-height: 4.518vw;
      font-size: 2.168vw;
      letter-spacing: -0.06px;
    }
    @media screen and (max-width: 768px) {
      height: 5.518vw;
      line-height: 5.518vw;
      font-size: 2.468vw;
      letter-spacing: -0.01px;
    }
    @media screen and (max-width: 580px) {
      height: 7.518vw;
      line-height: 7.518vw;
      font-size: 3.768vw;
      letter-spacing: 0px;
    }
    @media screen and (max-width: 380px) {
      height: 10.518vw;
      line-height: 10.518vw;
      font-size: 4.468vw;
      letter-spacing: 0px;
    }
  }
  &__containerdata {
    display: inline-block;
    width: 100%;
    height: 29.47vw;
    border-radius: 1.053vw;
    margin-top: 0.526vw;
    // background: gray;
    display: inline-flex;
    justify-content: space-between;
    @media screen and (max-width: 1120px) {
      height: 62.47vw;
    }
    @media screen and (max-width: 580px) {
      display: inline-block;
      height: auto;
      margin-top: 1.826vw;
    }
    &__img {
      width: 17.926vw;
      overflow: none;
      @media screen and (max-width: 1120px) {
        width: 38.737vw;
      }
      @media screen and (max-width: 1024px) {
        width: 39.737vw;
      }
      @media screen and (max-width: 768px) {
        width: 38.737vw;
      }
      @media screen and (max-width: 580px) {
        width: 100%;
        height: 90vw;
        overflow-y: hidden;
        overflow-x: hidden;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 16px;
        @media screen and (max-width: 580px) {
          height: auto;
        }
      }
    }
    &__strengscont {
      width: 25.62vw;
      margin-left: 0.632vw;
      background-color: #eff7fe;
      border-radius: 0.678vw;
      // overflow-x: auto;
      position: relative;
      overflow: hidden;
      @media screen and (max-width: 1120px) {
        width: 50.5vw;
      }
      @media screen and (max-width: 1024px) {
        width: 54.5vw;
      }
      @media screen and (max-width: 580px) {
        margin-top: 2.574vw;
        margin-left: 0vw;
        width: 100%;
        height: 118.4vw;
        padding-bottom: 2.147vw;
        border-radius: 14px;
      }
      @media screen and (max-width: 380px) {
        height: 174.4vw;
      }
      &__references {
        width: 17.474vw;
        height: 1.37vw;
        border-radius: 22px;
        background-color: #deecf8;
        margin: 0 auto;
        margin-top: 0.421vw;
        display: inline-flex;
        justify-content: space-between;
        padding-right: 0.8vw;
        position: relative;
        @media screen and (max-width: 1300px) {
          margin-top: 0.121vw;
        }
        @media screen and (max-width: 1220px) {
          margin-top: 0.021vw;
        }
        @media screen and (max-width: 1120px) {
          width: 40.5vw;
          height: 2.57vw;
          margin-top: 1.021vw;
        }
        @media screen and (max-width: 650px) {
          margin-top: 0.208vw;
        }
        @media screen and (max-width: 580px) {
          width: 94vw;
          height: 10.57vw;
          border-radius: 10px;
          margin-top: 1.211vw;
        }
        @media screen and (max-width: 480px) {
          width: 90vw;
        }
        @media screen and (max-width: 380px) {
          height: 15.57vw;
        }
        &__item:first-child {
          width: 3.485vw;
          display: inline-flex;
          justify-content: center;
          font-family: 'Roboto-Regular';
          font-size: 0.737vw;
          font-weight: normal;
          font-stretch: normal;
          position: relative;
          font-style: normal;
          line-height: 1.37vw;
          letter-spacing: -0.14px;
          text-align: center;
          color: #132839;
          @media screen and (max-width: 1120px) {
            width: 8.485vw;
            height: 2.57vw;
            font-size: 1.337vw;
            line-height: 2.57vw;
          }
          @media screen and (max-width: 580px) {
            position: absolute;
            width: 95%;
            height: 5.2vw;
            margin-left: 2.5%;
            border-bottom: 1px dotted black;
            line-height: 5.2vw;
            font-size: 2.54vw;
            margin-top: -0.214vw;
          }
          @media screen and (max-width: 380px) {
            height: 7.57vw;
            line-height: 7.57vw;
            font-size: 3.94vw;
          }
        }
        &__item {
          width: 4.1185vw;
          display: inline-flex;
          justify-content: center;
          font-family: 'Roboto-Regular';
          font-size: 0.737vw;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.37vw;
          position: relative;
          letter-spacing: -0.14px;
          text-align: left;
          color: #132839;
          @media screen and (max-width: 1120px) {
            width: 10.485vw;
            height: 2.57vw;
            font-size: 1.337vw;
            line-height: 2.57vw;
          }
          @media screen and (max-width: 580px) {
            margin-top: 6.447vw;
            font-size: 2.837vw;
            width: 32.1185vw;
          }
          @media screen and (max-width: 380px) {
            margin-top: 9.847vw;
            font-size: 3.537vw;
            width: 32.1185vw;
          }
        }
      }

      &__strengsitem {
        width: 24vw;
        height: 5.214vw;
        margin: 0 auto;
        position: relative;
        margin-top: 0.308vw;
        border-radius: 20px;
        box-shadow: 0 0 4px 0 rgba(44, 67, 89, 0.18);
        background-color: #84bf42;
        display: inline-flex;

        @media screen and (max-width: 1350px) {
          margin-top: 0.248vw;
          border-radius: 14px;
        }
        @media screen and (max-width: 1270px) {
          border-radius: 8px;
        }
        @media screen and (max-width: 1220px) {
          margin-top: 0.148vw;
        }
        @media screen and (max-width: 1120px) {
          width: 47.5vw;
          height: 11.05vw;
          margin-top: 0.548vw;
        }
        @media screen and (max-width: 1024px) {
          width: 51.5vw;
        }
        @media screen and (max-width: 580px) {
          width: 94vw;
          height: 20vw;
          margin-top: 1.11vw;
          border-radius: 18px;
        }
        @media screen and (max-width: 480px) {
          width: 90vw;
        }
        @media screen and (max-width: 380px) {
          height: 30vw;
        }

        &__img {
          width: 4.7vw;
          height: 4.7vw;
          margin-top: 0.27vw;
          margin-left: 0.21vw;
          background: white;
          border-radius: 19px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          align-content: center;
          @media screen and (max-width: 1350px) {
            border-radius: 14px;
          }
          @media screen and (max-width: 1270px) {
            border-radius: 8px;
          }
          @media screen and (max-width: 1120px) {
            width: 9.7vw;
            height: 9.7vw;
            margin-top: 0.67vw;
            margin-left: 0.71vw;
          }
          @media screen and (max-width: 580px) {
            width: 8.6vw;
            height: 8.4vw;
            margin-top: 1.87vw;
            margin-left: 2vw;
            position: absolute;
          }
          @media screen and (max-width: 380px) {
            height: 12.5vw;
            width: 12.5vw;
          }
          img {
            width: 3.4vw;
            @media screen and (max-width: 1120px) {
              width: 6.4vw;
            }
            @media screen and (max-width: 580px) {
              width: 6.4vw;
            }
            @media screen and (max-width: 380px) {
              width: 7.4vw;
            }
          }
        }
        &__datacont {
          width: 17.7vw;
          height: 4.7vw;
          // background: peru;
          margin-left: 0.877vw;
          margin-top: 0.27vw;
          @media screen and (max-width: 1270px) {
            margin-top: 0.17vw;
          }
          @media screen and (max-width: 1120px) {
            width: 35.7vw;
            height: 9.7vw;
            margin-top: 0.67vw;
            margin-left: 0.71vw;
          }
          @media screen and (max-width: 1024px) {
            width: 38.7vw;
          }
          @media screen and (max-width: 580px) {
            width: 98%;
            height: 20vw;
            margin: 0 auto;
          }
          &__row1 {
            width: 100%;
            height: 2.6vw;
            // background: #035eb2;
            display: inline-flex;
            justify-content: space-between;
            @media screen and (max-width: 1350px) {
              height: 2.4vw;
            }
            @media screen and (max-width: 1270px) {
              height: 1.9vw;
            }
            @media screen and (max-width: 1120px) {
              height: 4.9vw;
              // background: blue;
            }
            @media screen and (max-width: 580px) {
              height: 11vw;
            }
            @media screen and (max-width: 380px) {
              height: 16vw;
            }

            &__category {
              font-family: 'Roboto-Regular';
              font-size: 0.957vw;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.03;
              letter-spacing: -0.29px;
              text-align: left;
              color: #fff;
              margin-top: 0.579vw;
              @media screen and (max-width: 1350px) {
                margin-top: 0.379vw;
              }
              @media screen and (max-width: 1270px) {
                margin-top: 0vw;
              }
              @media screen and (max-width: 1120px) {
                font-size: 1.957vw;
                padding-top: 0.5vw;
              }
              @media screen and (max-width: 580px) {
                font-size: 3.657vw;
                padding-top: 2.2vw;
                padding-left: 12vw;
              }
              @media screen and (max-width: 380px) {
                font-size: 5.157vw;
                padding-top: 2.6vw;
                padding-left: 17vw;
              }
              &__bold {
                font-family: 'Roboto-Black';
              }
            }
            &__total {
              width: 3.07vw;
              height: 1.494vw;
              border-radius: 7px;
              background-color: #132839;
              font-family: 'Roboto-Black';
              font-size: 1.086vw;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.494vw;
              letter-spacing: -0.29px;
              text-align: center;
              color: #fff;
              margin-right: 0.8vw;
              margin-top: 0.447vw;
              @media screen and (max-width: 1350px) {
                border-radius: 5px;
                margin-top: 0.379vw;
              }
              @media screen and (max-width: 1270px) {
                margin-top: 0vw;
              }
              @media screen and (max-width: 1120px) {
                width: 6.07vw;
                height: 2.494vw;
                margin-top: 0.8vw;
                line-height: 2.794vw;
                font-size: 1.786vw;
              }
              @media screen and (max-width: 580px) {
                width: 11.07vw;
                height: 6.494vw;
                margin-top: 1.87vw;
                line-height: 6.494vw;
                font-size: 3.786vw;
                margin-right: 2.8vw;
              }
              @media screen and (max-width: 380px) {
                width: 15.07vw;
                height: 8.494vw;
                margin-top: 1.87vw;
                line-height: 8.494vw;
                font-size: 5.786vw;
                margin-right: 2.8vw;
              }
            }
          }
          &__row2 {
            width: 100%;
            height: 2vw;
            display: inline-flex;
            @media screen and (max-width: 1120px) {
              height: 4.3vw;
            }
            @media screen and (max-width: 580px) {
              height: 7.27vw;
            }
            @media screen and (max-width: 380px) {
              height: 12.27vw;
            }
            &__medal {
              width: 2vw;
              height: 2vw;
              @media screen and (max-width: 1120px) {
                width: 3.8vw;
                height: 3.8vw;
                margin-top: 0.545vw;
              }
              @media screen and (max-width: 580px) {
                width: 6.1vw;
                height: 6.1vw;
                margin-top: 0.545vw;
                margin-left: 1.4vw;
              }
              @media screen and (max-width: 380px) {
                height: 11.147vw;
                width: 11.147vw;
                margin-top: 0.845vw;
                margin-left: 1.4vw;
              }
              img {
                margin-top: 0.147vw;
              }
            }
            &__textposition {
              width: 9vw;
              height: 1.57vw;
              border-radius: 7px;
              background-color: #132839;
              font-family: 'Roboto-Regular';
              font-size: 0.757vw;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.57vw;
              letter-spacing: -0.19px;
              text-align: center;
              color: #fff;
              margin-top: 0.33vw;
              margin-left: 0.24vw;
              @media screen and (max-width: 1350px) {
                border-radius: 4px;
              }
              @media screen and (max-width: 1120px) {
                width: 17vw;
                height: 3vw;
                margin-top: 0.945vw;
                margin-left: 1.24vw;
                font-size: 1.457vw;
                line-height: 3vw;
              }
              @media screen and (max-width: 580px) {
                width: 29.8vw;
                height: 5.6vw;
                margin-top: 0.945vw;
                margin-left: 1.4vw;
                font-size: 2.557vw;
                line-height: 5.6vw;
              }
              @media screen and (max-width: 380px) {
                width: 40.8vw;
                height: 8.2vw;
                margin-top: 1.945vw;
                margin-left: 3.4vw;
                font-size: 3.757vw;
                line-height: 7.6vw;
              }
              &__bold {
                font-family: 'Roboto-Black';
                padding-right: 0.4vw;
              }
            }
            &__icon {
              width: 1.97vw;
              height: 1.57vw;
              border-radius: 14px;
              // background-color: #132839;
              margin-top: 0.33vw;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              align-content: center;
              margin-left: 3.74vw;
              @media screen and (max-width: 1600px) {
                width: 2.27vw;
                margin-left: 3.44vw;
                border-radius: 10px;
              }
              @media screen and (max-width: 1350px) {
                border-radius: 8px;
              }
              @media screen and (max-width: 1120px) {
                width: 3.5vw;
                height: 3vw;
                margin-top: 0.945vw;
                border-radius: 14px;
                margin-left: 9.44vw;
                font-size: 1.457vw;
                line-height: 3vw;
              }
              @media screen and (max-width: 1024px) {
                width: 4vw;
                height: 3vw;
                margin-top: 0.945vw;
                border-radius: 14px;
                margin-left: 11.94vw;
                font-size: 1.457vw;
                line-height: 3vw;
              }
              @media screen and (max-width: 768px) {
                width: 4.2vw;
                height: 3vw;
                margin-top: 0.945vw;
                border-radius: 11px;
                margin-left: 11.9vw;
                font-size: 1.457vw;
                line-height: 3vw;
              }
              @media screen and (max-width: 580px) {
                width: 7.8vw;
                height: 5.6vw;
                margin-top: 0.945vw;
                border-radius: 11px;
                margin-left: 42.9vw;
                font-size: 1.457vw;
                line-height: 3vw;
              }
              @media screen and (max-width: 480px) {
                margin-left: 38.9vw;
              }
              @media screen and (max-width: 380px) {
                margin-left: 15.9vw;
                width: 12.8vw;
                height: 8.2vw;
                margin-top: 1.445vw;
              }

              img {
                width: 1.4vw;
                @media screen and (max-width: 1120px) {
                  width: 2.97vw;
                }
                @media screen and (max-width: 580px) {
                  width: 5.4vw;
                }
                @media screen and (max-width: 380px) {
                  width: 7.4vw;
                }
              }
            }
          }
          &__sep {
            width: 100%;
            height: 0.093vw;
            border-bottom: 1px dotted #b8e28a;
            @media screen and (max-width: 1350px) {
              margin-top: 0.147vw;
            }
          }
        }
      }
    }
  }
}
</style>
